import { axios } from "../../../../Global";
import React, { useEffect, useState } from "react";
import { setBreadCrumb } from "../../../../store/userSlice";
import { AiOutlineFileText } from "react-icons/ai";
import { BiBookmarkAltPlus, BiUserPin } from "react-icons/bi";
import { FiUsers } from "react-icons/fi";
import { HiOutlineUserGroup } from "react-icons/hi";
import { IoCopyOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLoaderData } from "react-router-dom";
import { setAppError } from "../../../../store/userSlice";
import Shimmer from "../../../../utils/Shimmer";

export default function Dashboard() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [dataLoading, setDataLoading] = useState(false);
  const dashboardData = useSelector((state) => state.dashboardData);

  const { dashboardPage } = useSelector((state) => state.user);

  // useEffect(() => {
  //   if (dashboardPage === "Dashboard") {
  //     setDataLoading(true);
  //     axios
  //       .get("/dashboard/data", {
  //         headers: { Authorization: `Bearer ${token}` },
  //       })
  //       .then((res) => {
  //         setDataLoading(false);
  //         setDashboardData(res.data.data);
  //       })
  //       .catch((err) => {
  //         setDataLoading(false);
  //         dispatch(
  //           setAppError({
  //             msg: err.message,
  //           })
  //         );
  //       });
  //   }
  // }, []);

  const DashboardPageDetails = [
    {
      id: 1,
      name: dashboardData?.data?.total_quotations,
      icon: <BiBookmarkAltPlus size={"1.5rem"} />,
      href: "/dashboard/quotation",
      total: "Total Quotations",
      color: "bg-pink-300",
    },
    {
      id: 2,
      name: dashboardData?.data?.total_contracts,
      icon: <AiOutlineFileText size={"1.5rem"} />,
      href: "/dashboard/contract",
      total: "Total Contracts",
      color: "bg-sky-500",
    },
    {
      id: 3,
      name: dashboardData?.data?.total_employees,
      icon: <BiUserPin size={"1.5rem"} />,
      href: " ",
      total: "Total Employees",
      color: "bg-cyan-400",
    },
    {
      id: 4,
      name: dashboardData?.data?.total_projects,
      icon: <IoCopyOutline size={"1.5rem"} />,
      href: "/dashboard/project",
      total: "Total Projects",
      color: "bg-orange-400",
    },
    {
      id: 5,
      name: dashboardData?.data?.total_clients,
      icon: <FiUsers size={"1.5rem"} />,
      href: "/dashboard/client",
      total: "Total Clients",
      color: "bg-yellow-300",
    },
    {
      id: 6,
      name: dashboardData?.data?.total_vendors,
      icon: <HiOutlineUserGroup size={"1.5rem"} />,
      href: "/dashboard/recruitment-agency",
      total: "Total Vendors",
      color: "bg-violet-400",
    },
  ];
  const commonItems = [{ label: "DASHBOARD", link: "" }];
  useEffect(() => {
    dispatch(setBreadCrumb(commonItems));
  }, []);

  return (
    <>
      {dataLoading ? (
        <Shimmer />
      ) : (
        <div className="p-8 flex justify-center  flex-wrap gap-10">
          {DashboardPageDetails?.map((item, index) => (
            <Link key={item.id} to={item.href || "/dashboard"}>
              <div className="p-10 flex justify-between items-center h-full gap-6 bg-white dark:bg-dark2 dark:text-white max-w-xs w-full rounded-lg">
                <div className="flex flex-col gap-2">
                  <p className="text-gray text-sm">{item.total}</p>
                  <p className="text-4xl font-medium">{item?.name}</p>
                </div>
                <div
                  className={`p-4 dark:text-dark rounded-full ${item.color}`}
                >
                  {item.icon}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
